<template>
  <b-modal id="modal-scoped" v-model="openModal">
    <template #modal-header="{ close }">
      <h5>{{ infoModal.title }}</h5>
      <b-button size="sm" variant="light" @click="close()"> x </b-button>
    </template>

    <div class="modal-body" style="max-height: 500px; overflow-y: auto">
      <!-- Form nhập lý do cho các action cần reason -->
      <div
        v-if="
          ['CANCEL_PAYMENT', 'CREATE_RECOUPMENT', 'CANCEL_RECOUPMENT']?.includes(infoModal?.type)
        "
      >
        <div class="form-group">
          <label>Lý do <span class="text-danger">*</span></label>
          <textarea
            v-model="infoModal.reason"
            class="form-control"
            rows="3"
            placeholder="Nhập lý do..."
          ></textarea>
          <small class="text-danger" v-if="showError && !infoModal.reason">
            Vui lòng nhập lý do
          </small>
        </div>
      </div>

      <!-- Hiển thị thông tin cho tạo truy thu -->
      <div v-if="infoModal?.type === 'CREATE_RECOUPMENT'" class="recoupment-info">
        <div class="form-group">
          <label>Người hưởng:</label>
          <p>{{ infoModal?.userReceive?.name }}</p>
        </div>
        <div class="form-group">
          <label>Người bán:</label>
          <p>{{ infoModal?.userSell?.name }}</p>
        </div>
        <div class="form-group">
          <label>Serial thiết bị:</label>
          <p>{{ infoModal.serial }}</p>
        </div>
        <div class="form-group">
          <label>Merchant:</label>
          <p>{{ infoModal?.merchantName }}</p>
        </div>
        <div class="form-group">
          <label>Mã hợp đồng:</label>
          <p>{{ infoModal?.contractCode }}</p>
        </div>
        <div class="form-group">
          <label>Số tiền:</label>
          <p>{{ infoModal?.amount?.toLocaleString() }} đ</p>
        </div>
      </div>

      <!-- Message xác nhận cho các action khác -->
      <div v-else class="confirmation-message">
        <p v-if="infoModal?.type === 'MARK_PAID'">
          CTV {{ infoModal?.userSell?.name }} đã được thanh toán thành công?
        </p>
        <p v-if="infoModal?.type === 'MARK_RECOUPED'">
          CTV {{ infoModal?.userSell?.name }} đã được truy thu thành công?
        </p>
      </div>
    </div>

    <template #modal-footer="{ cancel }">
      <b-button variant="light" @click="cancel()"> Hủy bỏ </b-button>
      <b-button variant="primary" :disabled="loadingModal" @click="handleConfirm"
        >{{ loadingModal ? 'Đang tải...' : 'Xác nhận' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import {
    // getListTingboxCtv,
    cancelRecoupment,
    markAsRecouped,
    markAsPaid,
    createRecoupment,
    // exportExcelCtv
  } from '@/services/tingbox-ctv'
  import moment from 'moment'
  import { showMess } from '@/config/utils'

  export default {
    name: 'ModalComfirm',
    props: ['onLoad'],
    data() {
      return {
        openModal: false,
        infoModal: null,
        showError: false,
        loadingModal: false,
      }
    },
    methods: {
      // format date payload
      transformDatePayload() {
        // Thời gian tạo
        if (this.dateRange1.startDate && this.dateRange1.endDate) {
          this.search.createdDateFrom = moment(this.dateRange1.startDate).startOf('day').valueOf()
          this.search.createdDateTo = moment(this.dateRange1.endDate).endOf('day').valueOf()
        } else {
          this.search.createdDateFrom = 0
          this.search.createdDateTo = 0
        }

        // Thời gian thanh toán
        if (this.dateRange2.startDate && this.dateRange2.endDate) {
          this.search.paidDateFrom = moment(this.dateRange2.startDate).startOf('day').valueOf()
          this.search.paidDateTo = moment(this.dateRange2.endDate).endOf('day').valueOf()
        } else {
          this.search.paidDateFrom = 0
          this.search.paidDateTo = 0
        }

        // Thời gian truy thu
        if (this.dateRange3.startDate && this.dateRange3.endDate) {
          this.search.recoupmentDateFrom = moment(this.dateRange3.startDate)
            .startOf('day')
            .valueOf()
          this.search.recoupmentDateTo = moment(this.dateRange3.endDate).endOf('day').valueOf()
        } else {
          this.search.recoupmentDateFrom = 0
          this.search.recoupmentDateTo = 0
        }

        // Thời gian huỷ
        if (this.dateRange4.startDate && this.dateRange4.endDate) {
          this.search.canceledDateFrom = moment(this.dateRange4.startDate).startOf('day').valueOf()
          this.search.canceledDateTo = moment(this.dateRange4.endDate).endOf('day').valueOf()
        } else {
          this.search.canceledDateFrom = 0
          this.search.canceledDateTo = 0
        }
      },

      // comfirm action trạng thái
      async handleConfirm() {
        // Check validate cho các action cần reason
        if (
          ['CANCEL_PAYMENT', 'CREATE_RECOUPMENT', 'CANCEL_RECOUPMENT'].includes(
            this.infoModal.type
          ) &&
          !this.infoModal.reason
        ) {
          this.showError = true
          return
        }
        this.loadingModal = true
        try {
          switch (this.infoModal.type) {
            case 'CANCEL_PAYMENT':
              await this.handleCancelPayment()
              break
            case 'MARK_PAID':
              await this.handleMarkPaid()
              break
            case 'CREATE_RECOUPMENT':
              await this.handleCreateRecoupment()
              break
            case 'MARK_RECOUPED':
              await this.handleMarkRecouped()
              break
            case 'CANCEL_RECOUPMENT':
              await this.handleCancelRecoupment()
              break
          }

          // Đóng modal và refresh data
          this.openModal = false
          this.$emit('onLoad')
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.loadingModal = false
        }
      },

      // Hàm xử lý hủy thanh toán
      async handleCancelPayment() {
        try {
          const res = await cancelRecoupment({
            id: this.infoModal.id,
            note: this.infoModal.reason,
          })
          if (res.code === 1000) {
            showMess(
              this,
              'Success',
              res.message || 'Thao tác thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Dã có lỗi sảy ra',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      // Hàm xử lý đánh dấu đã thanh toán
      async handleMarkPaid() {
        try {
          const res = await markAsPaid({
            id: this.infoModal.id,
          })
          if (res.code === 1000) {
            showMess(
              this,
              'Success',
              res.message || 'Thao tác thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Dã có lỗi sảy ra',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      // Hàm xử lý tạo truy thu
      async handleCreateRecoupment() {
        try {
          const res = await createRecoupment({
            id: this.infoModal.id,
            note: this.infoModal.reason,
          })
          if (res.code === 1000) {
            showMess(
              this,
              'Success',
              res.message || 'Thao tác thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Dã có lỗi sảy ra',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      // Hàm xử lý đánh dấu đã truy thu
      async handleMarkRecouped() {
        try {
          const res = await markAsRecouped({
            id: this.infoModal.id,
          })
          if (res.code === 1000) {
            showMess(
              this,
              'Success',
              res.message || 'Thao tác thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Dã có lỗi sảy ra',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      // Hàm xử lý hủy truy thu
      async handleCancelRecoupment() {
        try {
          const res = await cancelRecoupment({
            id: this.infoModal.id,
            note: this.infoModal.reason,
          })
          if (res.code === 1000) {
            showMess(
              this,
              'Success',
              res.message || 'Thao tác thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Dã có lỗi sảy ra',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      // Update handleOpenModal method
      handleOpen(data, type) {
        this.openModal = true
        this.infoModal = {
          ...data,
          type,
          reason: '',
        }
        this.showError = false

        // Set title based on type
        switch (type) {
          case 'CANCEL_PAYMENT':
            this.infoModal.title = `Bạn có chắc chắn muốn hủy thanh toán cho CTV ${data.userSell?.name || ''}?`
            break
          case 'MARK_PAID':
            this.infoModal.title = 'Xác nhận thanh toán'
            break
          case 'CREATE_RECOUPMENT':
            this.infoModal.title = 'Tạo truy thu'
            break
          case 'MARK_RECOUPED':
            this.infoModal.title = 'Xác nhận truy thu'
            break
          case 'CANCEL_RECOUPMENT':
            this.infoModal.title = 'Hủy truy thu'
            break
        }
      },
    },
  }
</script>
